import type {
  PropertyHeroData,
  GalleryImage,
  PropertyStoryData,
  SignatureFeature,
  EssentialInfoGroup,
  PropertyReview,
  PropertyConciergeConfig,
  PropertyInquiryData,
  StickyBookBarData,
} from '../types';

export const heroData: PropertyHeroData = {
  id: 'belvedere',
  name: 'The Belvedere',
  location: 'Rosemary Beach',
  area: '30A',
  bedrooms: '7',
  bathrooms: '9',
  sleeps: 'Up to 20',
  heroImage: 'https://inspirevp.com/wp-content/uploads/2021/09/West-Gathering-Area-1_1.jpg',
  videoUrl: 'https://player.vimeo.com/video/772057726?autoplay=1&title=0&portrait=0&muted=0&loop=0',
  matterportUrl: 'https://my.matterport.com/show/?m=F12AZbdUQZS&mls=1',
};

const orderedGalleryUrls = [
  'https://inspirevp.com/wp-content/uploads/2021/09/West-Gathering-Area-1_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/West-Gathering-Area-4_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/East-Gathering-Room-2_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/West-Gathering-Area-3_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/West-Gathering-Area-2_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen-Island-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/The-Belvedere_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View7_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View8_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Town-Hall-Post-Office_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sugar-Shack_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/The-Belvedere-and-Main-Street-RB_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View5.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View4.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View3.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Sky-View.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Stairs-Level-2-to-level-3_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pool-4.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pool-From-Level-3-Balcony-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pool-from-Level-3-Balcony.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pool-Sky-View.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pool.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Post-Office.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pool-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Pascado.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Office-Level-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Main-Street.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Main-Street-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level3-Center-Balcony.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Deck-East-ViewC.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Deck-East-ViewD.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Deck-West-View.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Deck-West-ViewA.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Deck-West-ViewB.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Top-Deck-West-View-C.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Roof-Deck-East-View.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/East-Gathering-Room-Sitting-Area_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/East-Gathering-Room_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen-3.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen-Island.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen-1_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-Sitting-Room.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-South-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-South-Bathroom-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-Walk-In-Closet.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Bedroom-Suite-5-BathroomA.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Bedroom-Suite-5-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Hallway.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Gathering-Area.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-4A.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-5-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-5.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-5A.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-4-Bathroom1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-4-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-3A.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-3.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-3-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bedroom-Suite-3-Bathroom-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-South-Balcony.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-North-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-3.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-North-Bathroom-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-North-Bathroom-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Entryway-to-Primary-Suite.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Bedroom-Suite-2A.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Bedroom-Suite-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Hallway-Bathroom.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Hallway-BathroomA.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Laundry-Suite.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bunk-Room.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-4-Bunk-Roomm.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Bunk-Room-Level-2_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-5-Half-Bath.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-2-Half-Bath.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/West-Gathering-Area_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/East-Gathering-Room-4_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/East-Gathering-Room-3_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Entrance-Foyer-1_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Butler-Pantry_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Dining-Room-2_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Dining-Room-3_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Bar-4_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Bar-3_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Entrance-Foyer_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Entryway_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Grand-Entrace-Garage_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-2-Pool.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Beach-Access-Location_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Level-3-Primary-Suite-Balcony.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/La-Crema.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/09/Cowgirl-Kitchen_1.jpg',
];

export const galleryImages: GalleryImage[] = orderedGalleryUrls.map((src, index) => ({
  src,
  alt: `The Belvedere photo ${index + 1}`,
  caption: `Photo ${index + 1} of ${orderedGalleryUrls.length}`,
}));

export const storyData: PropertyStoryData = {
  subheading: 'Five levels of Rosemary Beach luxury, complete with rooftop views of the sunrise and sunset over the Gulf.',
  paragraphs: [
    "Spanning five levels and 7,400 square feet, The Belvedere is one of the finest homes in Rosemary Beach. Completed in late 2020 and located within The Providence \u2014 Rosemary\u2019s newest residential masterpiece \u2014 it was built to hold a family together without feeling crowded.",
    "You arrive through a private entrance foyer and step immediately into something exceptional. A light-filled staircase rises through every floor. The private elevator connects all five levels quietly, so arriving with luggage or moving between floors feels effortless from the first morning.",
    "The main living floor on Level 2 is anchored by a 30-foot kitchen island with waterfall edges and counter seating for eight. Two gathering rooms open off it \u2014 one facing the private pool, one opening onto the Rosemary Beach town center. A private dining room seats ten. Outside, the pool features programmable lighting, fountains, and jets, and a natural gas grill for evenings on the terrace.",
    "The Primary Suite occupies the entire east side of Level 3, with floor-to-ceiling windows overlooking the town center, two full bathrooms, a sitting room, and its own private balcony. Five additional bedroom suites are each distinctly furnished, giving every part of your group its own space and personality.",
    "At the top, Level 5 opens into more than a thousand square feet of rooftop living. The Gulf stretches 180 degrees to the horizon. Sunrise from the east, sunset from the west, and everything in between.",
  ],
  locationContext:
    "Step out the front door and you\u2019re steps from Restaurant Paradis, Pescado, La Crema, and Edwards. Walk or bike the 30A paths to Alys Beach and you\u2019ll find The Citizen and George\u2019s. Seacrest Beach is just a short walk away.",
  address: 'Rosemary Beach',
  addressSub: '30A, Florida Panhandle',
  propertyMeta: '5 levels \u00b7 7,400 sq. ft. \u00b7 Completed 2020 \u00b7 Within The Providence',
};

export const signatureFeatures: SignatureFeature[] = [
  {
    title: 'Private Pool',
    body: 'The Level 2 pool features programmable multicolored lights, fountains, and jets. It can be heated and overlooks one of the main outdoor living areas \u2014 the natural gathering point for mornings in and evenings out.',
    image: 'https://inspirevp.com/wp-content/uploads/2021/09/Pool-4.jpg',
    imageAlt: 'Private pool area \u2014 The Belvedere',
    tag: 'Level 2',
  },
  {
    title: 'Private Elevator',
    body: 'The elevator connects all five levels quietly from the moment you walk through the front door. Five floors, a dozen bags, or an armful of groceries \u2014 it makes every arrival and every evening easier.',
    image: '/images/properties/belvedere/belvedere-elevator1a-web.png',
    imageAlt: 'Private elevator entry \u2014 The Belvedere',
    tag: 'All 5 levels',
  },
  {
    title: 'Rooftop Living Area',
    body: "180-degree Gulf views from more than 1,000 square feet of open sky. Watch the sun rise over the east, set over the west, and in between \u2014 just be outside. A covered seating area, a bathroom just steps away, and as much room as you need to spread out.",
    image: 'https://inspirevp.com/wp-content/uploads/2021/09/East-Gathering-Room-2_1.jpg',
    imageAlt: 'Rooftop living \u2014 The Belvedere',
    tag: 'Level 5 \u00b7 Gulf views',
  },
  {
    title: 'The Kitchen',
    body: "A 30-foot island with waterfall edges and seating for eight anchors a world-class chef\u2019s kitchen: Sub-Zero refrigerator, Wolf range with six burners, three sinks, three dishwashers, and a wine refrigerator and bar in the adjacent beverage center.",
    image: 'https://inspirevp.com/wp-content/uploads/2021/09/Kitchen-Island-1.jpg',
    imageAlt: 'Kitchen island \u2014 The Belvedere',
    tag: 'Level 2',
  },
];

export const essentialInfoGroups: EssentialInfoGroup[] = [
  {
    heading: 'At a glance',
    items: [
      '7 Bedrooms',
      '9 Bathrooms',
      'Sleeps up to 20 guests',
      '5 levels \u00b7 7,400 sq. ft.',
      'Located in the heart of Rosemary Beach',
      'Private parking for two vehicles, including a private garage',
      'Pet Friendly (Additional Fee Per Pet, Pre-Approval Required)',
    ],
  },
  {
    heading: 'Key features',
    items: [
      'Private pool with programmable lights, fountains & jets',
      'Private elevator (all 5 levels)',
      '1,000+ sq. ft. rooftop outdoor living area with 180\u00b0 Gulf views',
      'Natural gas grill & outdoor living terrace',
    ],
  },
  {
    heading: 'The kitchen',
    items: [
      "30\u2019 kitchen island, counter seating for 8",
      '48\u201d Sub-Zero refrigerator',
      '48\u201d Wolf range \u2014 6 burners, double ovens & griddle',
      '3 sinks \u00b7 3 dishwashers',
      'Wine refrigerator & bar sink adjacent',
      'Breville dual coffee system',
    ],
  },
  {
    heading: 'The suites',
    items: [
      'Primary suite \u2014 king bed, two private bathrooms, sitting room & town-center balcony',
      '4 additional king bedroom suites, each with private bathroom & walk-in closet',
      '2 custom bunk rooms',
      'Laundry suite with dual high-capacity washers & dryers',
    ],
  },
  {
    heading: 'Around the home',
    items: [
      'Private dining room (seats 10)',
      'Two gathering rooms on Level 2',
      'Third gathering room on Level 4',
      'Beach towels provided',
    ],
  },
  {
    heading: 'The neighborhood',
    items: [
      'Steps to Restaurant Paradis, Pescado, La Crema & Edwards',
      'Walk or bike to Alys Beach & WaterColor',
      'Publix Grocery nearby',
      'Frank Brown Park, Pier Park & Shipwreck Island Water Park close by',
    ],
  },
];

export const reviews: PropertyReview[] = [
  {
    id: 'r1',
    title: 'Fabulous home in Rosemary!!!',
    body: "The property is amazing and the house is impeccable!! Don\u2019t miss sunset from the 5th floor seating area!!!! Wonderful home!!!!",
    author: 'Angela T.',
    date: 'May 2025',
    stars: 5,
  },
  {
    id: 'r2',
    title: 'Everything You Could Want!',
    body: "We rented the Belvedere for a tennis trip with friends. The main living floor is amazing and everything you would want. The kitchen island is perfect for a house this size. Since we visited in February, we requested the pool to be heated and it was the perfect temperature. Lots of hours were spent floating and enjoying the outdoor fireplace. The master is spectacular, spacious, and the perfect retreat. Overall, I would highly recommend this property. It will exceed your expectations!!!",
    author: 'Lyn H.',
    date: 'Feb 2023',
    stars: 5,
  },
  {
    id: 'r3',
    title: 'Stunning!',
    body: 'Stunning, perfectly located, beautifully decorated and very relaxing!',
    author: 'Alicia M.',
    date: 'Oct 2022',
    stars: 5,
  },
  {
    id: 'r4',
    title: 'Heavenly!',
    body: "We loved our family vacation at the Belvedere. The home was in perfect condition. We were thrilled with all the appliances and kitchen features. The pool was a huge hit with grandchildren and adults alike. The location is superb for restaurants, boutiques and of course the beach. Andy was responsive immediately and really worked to make every detail of our stay filled with enjoyment. If we could give TEN stars, we would.",
    author: 'Carol A.',
    date: 'May 2022',
    stars: 5,
  },
  {
    id: 'r5',
    title: 'Spring Break 2022',
    body: "The Belvedere is an exquisite property that feels more spacious than its listed square footage. The kitchen is perfect for cooking meals with bar seating and a wonderful dining table. We can\u2019t say enough about the gorgeous sunset views from the rooftop terrace. If you are looking for a luxurious vacation in the best location in Rosemary, just a stone\u2019s throw from the beach \u2014 this is the spot for you.",
    author: 'Rachel V.',
    date: 'Mar 2022',
    stars: 5,
  },
  {
    id: 'r6',
    title: '5 Star Stay & 5 Star Management Company',
    body: 'Stayed at this property prior to my wedding. Andy ensured everything was in excellent shape before we arrived and was even able to accommodate an early check-in. Upon arrival, we found a handwritten congratulation note and a very nice bottle to celebrate. The property exceeded our expectations. The location was top notch.',
    author: 'Ryan T.',
    date: 'Oct 2021',
    stars: 5,
  },
];

export const conciergeConfig: PropertyConciergeConfig = {
  propertyId: 'belvedere',
  propertyName: 'The Belvedere',
  introText:
    "Hello \u2014 I\u2019m here to help you get to know The Belvedere. Ask me anything about the property: how many it sleeps, the pool, the rooftop, or anything else on your mind.",
  seedQuestion: 'Would this work for 18 guests?',
  starters: [
    'How many people does it sleep?',
    'Does it have a pool?',
    'Is there an elevator?',
    'Tell me about the rooftop.',
    'Would this work for 18 guests?',
    'Does it allow pets?',
    "What\u2019s nearby?",
  ],
};

export const inquiryData: PropertyInquiryData = {
  propertyName: 'The Belvedere',
  propertyLocation: 'Rosemary Beach',
  sleeps: '20',
};

export const stickyBarData: StickyBookBarData = {
  propertyId: 'belvedere',
  propertyName: 'The Belvedere',
  location: 'Rosemary Beach \u00b7 30A',
  bedrooms: '7 bed',
  sleeps: 'Sleeps 20',
};
